import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCar, FaCouch, FaHome, FaShower, FaChair, FaBed, FaClock } from 'react-icons/fa';
import axios from 'axios';
import './Services.css';

const Services = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeCategory, setActiveCategory] = useState("citadine");

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await axios.get('https://backend.time-to-clean.com/api/services');
                const filteredServices = response.data.map(({ price, ...service }) => service); // Exclure le prix
                setServices(filteredServices);
            } catch (err) {
                setError('Erreur lors du chargement des services.');
            } finally {
                setLoading(false);
            }
        };
        fetchServices();
    }, []);

    if (loading) return <div className="loading">Chargement des services...</div>;
    if (error) return <div className="error-message">{error}</div>;

    // ** Regroupement des services en catégories **
    const categories = {
        citadine: services.filter(service => service.name.toLowerCase().includes("citadine")),
        berline: services.filter(service => service.name.toLowerCase().includes("berline")),
        suv: services.filter(service => service.name.toLowerCase().includes("suv") || service.name.toLowerCase().includes("monospace")),
        fauteuils: services.filter(service => service.name.toLowerCase().includes("fauteuil")),
        canapes: services.filter(service => service.name.toLowerCase().includes("canapé")),
        matelas: services.filter(service => service.name.toLowerCase().includes("matelas")),
        exterieur: services.filter(service => service.name.toLowerCase().includes("lavage extérieur"))
    };

    return (
        <section className="services-section" id="services">
            <div className="services-container">
                <div className="section-header">
                    <h2>Nos Services</h2>
                    <p>Découvrez nos solutions de nettoyage écologiques et professionnelles</p>
                </div>

                {/* ** Onglets de catégories ** */}
                <div className="service-tabs">
                    {Object.keys(categories).map(category => (
                        <button 
                            key={category} 
                            className={`tab-button ${activeCategory === category ? "active" : ""}`} 
                            onClick={() => setActiveCategory(category)}
                        >
                            {category === "citadine" ? <FaCar /> : 
                             category === "berline" ? <FaCar /> : 
                             category === "suv" ? <FaCar /> : 
                             category === "fauteuils" ? <FaChair /> : 
                             category === "canapes" ? <FaCouch /> : 
                             category === "matelas" ? <FaBed /> : 
                             <FaShower />}
                            {category === "citadine" ? " Citadine" : 
                             category === "berline" ? " Berline" : 
                             category === "suv" ? " SUV/Monospace" : 
                             category === "fauteuils" ? " Fauteuils" : 
                             category === "canapes" ? " Canapés" : 
                             category === "matelas" ? " Matelas" : 
                             " Nettoyage Extérieur"}
                        </button>
                    ))}
                </div>

                {/* ** Liste des services filtrée selon la catégorie active ** */}
                <div className="services-grid">
                    {categories[activeCategory].map((service) => (
                        <div className="service-card" key={service._id}>
                            <div className="service-icon">
                                {activeCategory === "citadine" || activeCategory === "berline" || activeCategory === "suv" ? <FaCar /> : 
                                 activeCategory === "fauteuils" ? <FaChair /> : 
                                 activeCategory === "canapes" ? <FaCouch /> : 
                                 activeCategory === "matelas" ? <FaBed /> : 
                                 <FaShower />}
                            </div>
                            <h3>{service.name}</h3>
                            <p>{service.description || "Service de nettoyage professionnel et écologique."}</p>
                            
                            {/* Bloc durée + bouton aligné en bas */}
                            <div className="service-bottom">
                                <div className="service-duration">
                                    <FaClock /> {service.duration} min
                                </div>
                                <Link to={`/booking?service=${service._id}`} className="service-cta">
                                    Réserver maintenant
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;

